import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import type { BenchmarkReport } from '../../types/benchmark';

interface PerfectDocumentsCardProps {
  report: BenchmarkReport;
}

export function PerfectDocumentsCard({ report }: PerfectDocumentsCardProps) {
  const data = [
    { name: 'Parfaits', value: report.document_level.perfect_documents, color: '#10b981' },
    { name: 'Erreurs mineures', value: report.document_level.minor_error_documents, color: '#fbbf24' },
    { name: 'Erreurs critiques', value: report.document_level.critical_error_documents, color: '#ef4444' },
  ];

  const perfectRate = (Number(report.document_level.perfect_document_rate) * 100).toFixed(1);

  return (
    <div className="bg-white p-6 border rounded-lg">
      <h3 className="text-lg font-semibold mb-4">Documents parfaits</h3>

      <div className="text-center mb-4">
        <div className="text-4xl font-bold text-green-600">{perfectRate}%</div>
        <div className="text-sm text-gray-500">
          {report.document_level.perfect_documents}/{report.summary.total_documents} documents
        </div>
      </div>

      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
            isAnimationActive={false}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>

      <div className="mt-4 space-y-2">
        <div className="flex justify-between items-center">
          <span className="flex items-center">
            <span className="w-3 h-3 rounded-full bg-green-500 mr-2"></span>
            <span className="text-sm">Parfaits</span>
          </span>
          <span className="text-sm font-medium">{report.document_level.perfect_documents}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="flex items-center">
            <span className="w-3 h-3 rounded-full bg-yellow-500 mr-2"></span>
            <span className="text-sm">Erreurs mineures</span>
          </span>
          <span className="text-sm font-medium">{report.document_level.minor_error_documents}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="flex items-center">
            <span className="w-3 h-3 rounded-full bg-red-500 mr-2"></span>
            <span className="text-sm">Erreurs critiques</span>
          </span>
          <span className="text-sm font-medium">{report.document_level.critical_error_documents}</span>
        </div>
      </div>
    </div>
  );
}
